import { render } from "./production.vue?vue&type=template&id=0f1799a7"
import script from "./production.vue?vue&type=script&lang=js"
export * from "./production.vue?vue&type=script&lang=js"

import "./production.vue?vue&type=style&index=0&id=0f1799a7&lang=css"
script.render = render

export default script